import { Redirect } from "react-router-dom";

//Dashboard
import Dashboard from "../pages/DashboardCrm";

//Metiers Pages
import JobsPage from "../pages/Activities/Metiers";
import MetiersAdd from "../pages/Activities/Metiers/MetiersAdd";
import MetiersUpdate from "../pages/Activities/Metiers/MetiersUpdate";

import Enterprise from "../pages/Pages/Team/Enterprise";
import UserDetail from "../pages/Pages/Team/profilTeam";
import Team from "../pages/Pages/Team/Team";

// Opportunités
import OpportunitesAddNew from "../pages/Opportunites/OpportunitesAddNew";
import OpportunitesDetails from "../pages/Opportunites/OpportunitesDetails";
import OpportunitesUpdate from "../pages/Opportunites/OpportunitesUpdate";

//Ecommerce Pages
import ArticlesAdd from "../pages/Activities/Articles/ArticlesAdd";
import ArticlesDetails from "../pages/Activities/Articles/ArticlesDetails";
import ArticlesUpdate from "../pages/Activities/Articles/ArticlesUpdate";
import Articles from "../pages/Activities/Articles/index";
import EcommerceAddCategories from "../pages/Activities/Categories/EcommerceAddCategories";
import EcommerceUpdateCategories from "../pages/Activities/Categories/EcommerceUpdateCategories";
import Categories from "../pages/Activities/Categories/index";

//pages
import SettingsSimple from "../pages/Pages/Profile/Settings/SettingsSimple";
import Stock from "../pages/stock/Stock";

//login
import ArticleValidation from "../pages/Activities/Articles/ArticleValidation";
import Login from "../pages/Authentication/Login";
import LoginEn from "../pages/Authentication/LoginEn";

//Administration
import Abonnes from "../pages/Administration/Abonnes";

// User Profile
import AbonnesFormule from "../pages/Administration/AbonnesFormule";
import AdminsDemos from "../pages/Administration/AdminsDemos";
import DemosAdmins from "../pages/Administration/DemosAdmins";
import SimplePageAdmin from "../pages/Administration/SimplePageAdmin";
import UserProfile from "../pages/Authentication/user-profile";

import Collaborateurs from "../pages/Pages/Collaborateurs";
import CollaborateursAdd from "../pages/Pages/Collaborateurs/CollaborateursAdd";
import CollaborateursDetails from "../pages/Pages/Collaborateurs/CollaborateursDetails";

import RecruitmentsPage from "../pages/Recrutements";
import RecrutementsAdd from "../pages/Recrutements/RecrutementsAdd";
import RecrutementsDetails from "../pages/Recrutements/RecrutementsDetails";
import RecrutementsUpdate from "../pages/Recrutements/RecrutementsUpdate";

import AppelsdOffres from "../pages/AppelsdOffres";
import AppelsdOffresAdd from "../pages/AppelsdOffres/AppelsdOffresAdd";
import AppelsdOffresDetails from "../pages/AppelsdOffres/AppelsdOffresDetails";
import AppelsdOffresUpdate from "../pages/AppelsdOffres/AppelsdOffresUpdate";
import Experts from "../pages/Experts";
import ExpertsDetails from "../pages/Experts/ExpertsDetails";
import ExpertValidtion from "../pages/Experts/ExpertValidtion";

import QuestionsAnswersPage from "../pages/Questions";
import QuestionsAdd from "../pages/Questions/QuestionsAdd";
import QuestionsDetails from "../pages/Questions/QuestionsDetails";
import QuestionsToResponded from "../pages/Questions/QuestionsToResponded";

import Formations from "../pages/Formations";
import FormationsAdd from "../pages/Formations/FormationsAdd";
import FormationsDetails from "../pages/Formations/FormationsDetails";
import FormationsUpdate from "../pages/Formations/FormationsUpdate";

import PromotedProducts from "../pages/PromotedProducts";
import ProductForm from "../pages/PromotedProducts/ProductForm";
import ProductDetails from "../pages/PromotedProducts/ProductDetails";
import PendingProducts from "../pages/PromotedProducts/PendingProducts";
import ProductCategories from "../pages/PromotedProducts/ProductCategories";
import Innovations from "../pages/Innovations";
import InnovationsAdd from "../pages/Innovations/InnovationsAdd";
import InnovationsDetail from "../pages/Innovations/InnovationsDetails";
import InnovationsUpdate from "../pages/Innovations/InnovationsUpdate";

import SubscriptionTypesPage from "../pages/SubscriptionTypes";
import AbonnementsAdd from "../pages/SubscriptionTypes/AbonnementsAdd";
import AbonnementsDetails from "../pages/SubscriptionTypes/AbonnementsDetails";
import AbonnementUpdate from "../pages/SubscriptionTypes/AbonnementUpdate";

import AdminMessaging from "../pages/Assistance/AdminMessaging";

import AdvertisementsPage from "../pages/Publicities";
import AppVersionPolicy from "../pages/Settings/AppVersionPolicy";
import PublicitiesAdd from "../pages/Publicities/PublicitiesAdd";
import PublicitiesDetails from "../pages/Publicities/PublicitiesDetails";
import PublicitiesUpdate from "../pages/Publicities/PublicitiesUpdate";
import PublicitiesValidation from "../pages/Publicities/PublicitiesValidation";

import FormationPro from "../pages/FormationPro";
import Professionnel from "../pages/Pages/Team/Professionnel";

import FunctionsPage from "../pages/Fonctions";
import FormationLevel from "../pages/FormationLevel";
import CollaborateursUpdate from "../pages/Pages/Collaborateurs/CollaborateursUpdate";

import Banks from "../pages/Pages/Team/Banks";
import Certification from "../pages/Pages/Team/Certification";
import Organisme from "../pages/Pages/Team/Organisme";
import Particulier from "../pages/Pages/Team/Particulier";

// Pays
import AddArrondissement from "../pages/Geolocalisation/Arrondissement/AddArrondissement";
import Arrondissement from "../pages/Geolocalisation/Arrondissement/Arrondissement";
import UpdateArrondissement from "../pages/Geolocalisation/Arrondissement/UpdateArrondissement";
import AddQuartier from "../pages/Geolocalisation/Quartier/AddQuartier";
import Quartier from "../pages/Geolocalisation/Quartier/Quartier";
import UpdateQuartier from "../pages/Geolocalisation/Quartier/UpdateQuartier";
import AddTeamMember from "../pages/Pages/Team/AddTeamMember";
import AddStaffMember from "../pages/Pages/Team/AddStaffMember";
import UsersCategories from "../pages/Structures";
import AddCategories from "../pages/Structures/AddCategories";
import UpdateCategories from "../pages/Structures/UpdateCategories";
import SubCategories from "../pages/Structures/SubCategories";
import AddSubCategory from "../pages/Structures/SubCategories/AddSubCategory";
import UpdateSubCategory from "../pages/Structures/SubCategories/UpdateSubCategory";
import ProfilePage from "../pages/Profile/Profile";

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },

  { path: "/profile-users/:id/", component: UserDetail },
  { path: "/particuliers", component: Particulier },
  { path: "/banks", component: Banks },
  //Gestions des stocks
  { path: "/stock", component: Stock },

  { path: "/formationspro", component: FormationPro },

  { path: "/formations", component: Formations },
  { path: "/formations-add", component: FormationsAdd },
  { path: "/formations-update/:id", component: FormationsUpdate },
  { path: "/formations-details/:id", component: FormationsDetails },

  { path: "/promoted-products", component: PromotedProducts },
  { path: "/promoted-products-add", component: ProductForm },
  { path: "/promoted-products-update/:id", component: ProductForm },
  { path: "/promoted-products-details/:id", component: ProductDetails },
  { path: "/promoted-products-pending", component: PendingProducts },
  { path: "/promoted-products-categories", component: ProductCategories },

  { path: "/innovations", component: Innovations },
  { path: "/innovations-add", component: InnovationsAdd },
  { path: "/innovations-update/:id", component: InnovationsUpdate },
  { path: "/innovations-details/:id", component: InnovationsDetail },

  { path: "/functions", component: FunctionsPage },

  { path: "/level", component: FormationLevel },

  { path: "/technical-support", component: AdminMessaging },
  { path: "/technical-support-add/:id", component: AdminMessaging },
  { path: "/technical-support-details/:id", component: AdminMessaging },
  { path: "/technical-support-toResponded", component: AdminMessaging },

  { path: "/opportunites-add", component: OpportunitesAddNew },
  { path: "/opportunites-update/:id", component: OpportunitesUpdate },
  { path: "/opportunites-details/:id", component: OpportunitesDetails },

  { path: "/questions-answers", component: QuestionsAnswersPage },
  { path: "/questions-answers-add/:id", component: QuestionsAdd },
  { path: "/questions-answers-details/:id", component: QuestionsDetails },
  {
    path: "/questions-answers-to-responded/:id",
    component: QuestionsToResponded,
  },

  { path: "/subscription-types", component: SubscriptionTypesPage },
  { path: "/subscription-types-add", component: AbonnementsAdd },
  { path: "/subscription-types-details/:id", component: AbonnementsDetails },
  { path: "/subscription-types-update/:id", component: AbonnementUpdate },

  //Ecommerce
  { path: "/articles", component: Articles },
  { path: "/articles-validation/:id", component: ArticleValidation },
  { path: "/articles-update/:id", component: ArticlesUpdate },
  { path: "/articles-details/:id", component: ArticlesDetails },
  { path: "/articles-add", component: ArticlesAdd },
  //Ecommerce
  { path: "/advertisements", component: AdvertisementsPage },
  {
    path: "/advertisements-validation/:id",
    component: PublicitiesValidation,
  },
  { path: "/advertisements-update/:id", component: PublicitiesUpdate },
  { path: "/advertisements-details/:id", component: PublicitiesDetails },
  { path: "/advertisements-add", component: PublicitiesAdd },

  { path: "/collaborateurs", component: Collaborateurs },
  {
    path: "/collaborateurs-details/:id",
    component: CollaborateursDetails,
  },
  { path: "/collaborateurs-update/:id", component: CollaborateursUpdate },
  { path: "/collaborateurs-add", component: CollaborateursAdd },

  //Experts
  { path: "/experts", component: Experts },
  { path: "/experts-details/:id", component: ExpertsDetails },
  { path: "/experts-validation/:id", component: ExpertValidtion },
  { path: "/settings/app-version", component: AppVersionPolicy },

  { path: "/jobs", component: JobsPage },
  { path: "/jobs-update/:id", component: MetiersUpdate },
  { path: "/jobs-add", component: MetiersAdd },

  { path: "/categories-add", component: EcommerceAddCategories },
  { path: "/categories-update/:id", component: EcommerceUpdateCategories },
  { path: "/categories", component: Categories },

  { path: "/recruitments", component: RecruitmentsPage },
  { path: "/recruitments-update/:id", component: RecrutementsUpdate },
  { path: "/recruitments-details/:id", component: RecrutementsDetails },
  { path: "/recruitments-add", component: RecrutementsAdd },

  //Appels d'Offres
  { path: "/appels-offres", component: AppelsdOffres },
  { path: "/appels-offres-add", component: AppelsdOffresAdd },
  { path: "/appels-offres-update/:id", component: AppelsdOffresUpdate },
  { path: "/appels-offres-details/:id", component: AppelsdOffresDetails },

  // Profile
  { path: "/pages-profile", component: ProfilePage },
  { path: "/pages-profile/:id", component: SettingsSimple },
  { path: "/certification", component: Certification },

  //Team
  { path: "/pages-team", component: Team },
  { path: "/pages-team-add-user", component: AddTeamMember },
  { path: "/pages-team-add-staff", component: AddStaffMember },
  { path: "/organismes", component: Organisme },
  { path: "/professionals", component: Professionnel },
  { path: "/enterprises", component: Enterprise },
  { path: "/pages-admin-team", component: AdminsDemos },
  { path: "/pages-demos-team", component: DemosAdmins },

  //User Profile
  { path: "/profile", component: UserProfile },

  //Administration Access
  { path: "/admin-users", component: Abonnes },
  { path: "/admin-abonnes", component: AbonnesFormule },
  { path: "/admin-abonne-detail/:id", component: SimplePageAdmin },

  // Arrondissement
  { path: "/geolocalisation-arrondissement", component: Arrondissement },
  {
    path: "/geolocalisation-arrondissement-add",
    component: AddArrondissement,
  },
  {
    path: "/geolocalisation-arrondissement-update/:id",
    component: UpdateArrondissement,
  },

  // Quartier
  { path: "/geolocalisation-quartier", component: Quartier },
  { path: "/geolocalisation-quartier-add", component: AddQuartier },
  {
    path: "/geolocalisation-quartier-update/:id",
    component: UpdateQuartier,
  },

  // Institution categories ("Entreprise étatique"), and the institutions
  // inside them ("Ministère de la Justice").
  { path: "/utilisateurs-categories-add", component: AddCategories },
  {
    path: "/utilisateurs-categories-update/:id",
    component: UpdateCategories,
  },
  { path: "/utilisateurs-categories", component: UsersCategories },
  { path: "/utilisateurs-institutions-add", component: AddSubCategory },
  {
    path: "/utilisateurs-institutions-update/:id",
    component: UpdateSubCategory,
  },
  { path: "/utilisateurs-institutions", component: SubCategories },

  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
];

const publicRoutes = [
  { path: "/fr/connexion", component: Login },
  { path: "/en/login", component: LoginEn },
];

export { authProtectedRoutes, publicRoutes };
